export default __webpack_public_path__ + "static/media/024-turn-right-1.364954e1.png";